import React, { useState } from "react";
import styled from "styled-components";
import { Box, CssBaseline, Drawer, Typography } from "@material-ui/core";

import Header from "components/Header";
import Sidebar from "components/Sidebar";
import Footer from "components/Footer";
import Tooltip from "rc-tooltip";
import { TutorialWrapper } from "features/tutorial/TutorialWrapper";

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.div`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};
`;

const LinePopup = styled.div`
  position: fixed;
  bottom: 10px;
  right: 10px;
  cursor: pointer;
`;

const Main: React.FC = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Root>
      <CssBaseline />
      <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
        <Sidebar />
      </Drawer>
      <AppContent>
        <Header onDrawerToggle={handleDrawerToggle} />
        <MainContent>{children}</MainContent>
        <Footer />
        <LinePopup
          onClick={() => {
            window.open("https://lin.ee/fctnyNX", "_blank");
          }}
        >
          <Tooltip
            trigger="hover"
            placement="bottomRight"
            overlayStyle={{ zIndex: "1201" }}
            overlay={
              <Box display={"flex"} flexDirection={"column"} padding={1}>
                <Typography>お問い合わせはLINEから</Typography>
              </Box>
            }
          >
            <img src="/line.png" width="50" height="50" alt={"line popup"} />
          </Tooltip>
        </LinePopup>
      </AppContent>
      <TutorialWrapper />
    </Root>
  );
};

export default Main;
